/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import CouponInputPopup from './CouponInput'
import CouponCheckPopup from './CouponCheck'

const CouponPopup: React.FC = () => {

  return (
    <Fragment>
      <CouponInputPopup />
      <CouponCheckPopup />
    </Fragment>
  )
}
export default observer(CouponPopup)
